export const addZero = (num) => {
  return (num < 10) ? `0${num}` : num;
}
